import React from 'react';

export default function( props ) {
	return <h1>{ props.children }</h1>;
}



// WEBPACK FOOTER //
// ./src/components/wp/admin-header.js